export default [
    {
        path: 'admin/central/home',
        component: require('./Home').default,
        meta: {
            middleware: 'auth',
            controller: 'SuporteController'
        }
    },
    {
        path: 'admin/suportes',
        component: require('./Read').default,
        meta: {
            middleware: 'auth',
            controller: 'SuporteController'
        }
    },
    {
        path: 'admin/suportes/add',
        component: require('./Add').default,
        meta: {
            middleware: 'auth',
            controller: 'SuporteController'
        },
    },
    {
        path: 'admin/suportes/edit/:uuid',
        component: require('./Edit').default,
        meta: {
            middleware: 'auth',
            controller: 'SuporteController'
        },
    }
];
